<template>
  <div>
    <error-view :title="errorPageTitle" :content="errorPageContent" v-if="errorPageIsVisible" />
    <loader-view :content="loaderContent" v-if="loaderIsVisible && !errorPageIsVisible" />
    <router-view v-if="!loaderIsVisible && !errorPageIsVisible" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ErrorView from '@/components/shared/ErrorView';
import LoaderView from '@/components/shared/LoaderView';

export default {
  name: 'router-view-with-error-and-loader',
  components: {
    ErrorView,
    LoaderView,
  },
  computed: mapState({
    loaderIsVisible: (state) => state.loader.loaderIsVisible,
    loaderContent: (state) => state.loader.loaderContent,
    errorPageIsVisible: (state) => state.errorPage.errorPageIsVisible,
    errorPageTitle: (state) => state.errorPage.errorPageTitle,
    errorPageContent: (state) => state.errorPage.errorPageContent,
  }),
};
</script>

<style></style>
